var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 27,
    height: 33,
    rx: 4,
    fill: "#246FE1",
    fillOpacity: 0.22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 26,
    height: 32,
    rx: 3.5,
    stroke: "#246FE1",
    strokeOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 19,
    height: 26,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.33333C7.5 1.76853 8.76853 0.5 10.3333 0.5H16.6667C18.2315 0.5 19.5 1.76853 19.5 3.33333C19.5 3.97767 18.9777 4.5 18.3333 4.5H8.66667C8.02233 4.5 7.5 3.97767 7.5 3.33333Z",
    fill: "#E8F1FF",
    stroke: "#ADC9F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H13",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H19",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H16",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H15",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25H12",
    stroke: "black",
    strokeOpacity: 0.17,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 22.5,
    r: 6.5,
    fill: "#246FE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23L25 24.5L28.5 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e2c02942f9a92e64959e93ba44d468d8.svg";
export { ForwardRef as ReactComponent };